import { render, staticRenderFns } from "./PlatformCard.vue?vue&type=template&id=6ba3bad8&scoped=true"
import script from "./PlatformCard.vue?vue&type=script&lang=js"
export * from "./PlatformCard.vue?vue&type=script&lang=js"
import style0 from "./PlatformCard.vue?vue&type=style&index=0&id=6ba3bad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3bad8",
  null
  
)

export default component.exports